import { useState, useEffect } from "react";
import Headerdash from "./headerdash";
import { useParams } from "react-router-dom";
import SunEditor from "suneditor-react";

const Legal = () => {
    const {some} = useParams();
    const [content, setContent] = useState('loading...');

    useEffect(() => {
        fetch('https://api.voicecoach.net/view-legal/'+some, {headers: {'Content-type': 'application/json'}})
    .then(res => res.json())
    .then(jr => {setContent(jr.content);});
    }, [some])

    const [saveText, saveTextSet] = useState('Save ' + some);

    const submitLegal = () => {
        saveTextSet('Saving... Please wait.');
            let ac = {};
            ac['content'] = content;
            fetch('https://api.voicecoach.net/update-legal/'+some, {credentials: 'include', headers: {'Content-type':'application/json'},
            body: JSON.stringify(ac), method: 'post'})
            .then(res => { if (res.status === 401) { alert('You shall not pass!'); window.location.href = '/login' } return res.json()})
            .then(sj => {window.open('/legal/'+some); saveTextSet('Saved!');});
        }
    return <><Headerdash />
    <section>
    <div className="container">
    <h4 className="my-3">You are editing: {some}</h4>
    <SunEditor autoFocus={true}
    setContents={content}
    onChange={(elem) => {
        setContent(elem);
    }}
    height={400}
    />
    <button onClick={() => submitLegal()} className="btn btn-primary my-3">{saveText}</button>
    </div></section></>
}

export default Legal;